import { CURRENCY_CODE } from './currency';

export const MAINTENANCE_CHARGE = 500;

export const FEATURE_PRICING_OPTIONS = [
  { key: 'onboardingSetup', label: 'Onboarding and Setup', price: 500 },
  { key: 'invoice', label: 'Invoice', price: 300 },
  { key: 'trainerStaffManagement', label: 'Trainer and Staff Management', price: 300 },
  { key: 'slotBooking', label: 'Slot Booking', price: 250 },
  { key: 'memberRetention', label: 'Member Retention', price: 250 },
];

export const toAmount = value => {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount : 0;
};

export const getDefaultOnboardingPricing = () => ({
  currency: CURRENCY_CODE,
  maintenanceCharge: MAINTENANCE_CHARGE,
  features: FEATURE_PRICING_OPTIONS.map(feature => ({
    ...feature,
    selected: true,
  })),
  monthlyFeatureTotal: FEATURE_PRICING_OPTIONS.reduce((total, feature) => total + feature.price, 0),
  finalMonthlyCost: FEATURE_PRICING_OPTIONS.reduce((total, feature) => total + feature.price, MAINTENANCE_CHARGE),
  finalMonthlyCostEdited: false,
});

export const normalizeOnboardingPricing = pricing => {
  const savedFeatures = new Map((pricing?.features || []).map(feature => [feature.key, feature]));
  const features = FEATURE_PRICING_OPTIONS.map(defaultFeature => ({
    ...defaultFeature,
    ...(savedFeatures.get(defaultFeature.key) || {}),
  }));

  return calculateOnboardingPricing({
    ...getDefaultOnboardingPricing(),
    ...(pricing || {}),
    currency: pricing?.currency || CURRENCY_CODE,
    features,
  });
};

export const calculateOnboardingPricing = pricing => {
  const base = pricing || getDefaultOnboardingPricing();
  const monthlyFeatureTotal = (base.features || []).reduce(
    (total, feature) => total + (feature.selected ? toAmount(feature.price) : 0),
    0
  );
  const maintenanceCharge = toAmount(base.maintenanceCharge);

  return {
    ...base,
    currency: base.currency || CURRENCY_CODE,
    maintenanceCharge,
    monthlyFeatureTotal,
    finalMonthlyCost: base.finalMonthlyCostEdited
      ? toAmount(base.finalMonthlyCost)
      : monthlyFeatureTotal + maintenanceCharge,
  };
};
